module.exports = __webpack_public_path__ + "DINNextLTPro-HeavyCondensed.woff?e55d3e8b6a99f882493e6ad26001c8cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-HeavyCondensed.woff
// module id = 1428
// module chunks = 0